import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../services/notification.service';
import { LightspeedAuthService } from '../services/lightspeed-auth.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-content',
  imports: [],
  templateUrl: './content.component.html',
  styleUrl: './content.component.scss',
  standalone: true,
})
export class ContentComponent implements OnInit, AfterViewInit {
  private _code: string | null;

  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _notificationService: NotificationService,
    private readonly _lightSpeedAuthService: LightspeedAuthService,
  ) {
    this._code = '';
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this._code = this._route.snapshot.queryParamMap.get('code');
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/dc415059-8540-4e1d-8e84-d3a0bdc2efb3', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: 'debug-session',
        runId: 'initial',
        hypothesisId: 'D',
        location: 'content.component.ts:27',
        message: 'ngAfterViewInit query param code read',
        data: { hasCode: this._code !== null && this._code !== undefined },
        timestamp: Date.now(),
      }),
    }).catch(() => {});
    // #endregion
    // Log any OAuth errors returned on callback
    const errorParam = this._route.snapshot.queryParamMap.get('error');
    const errorDescriptionParam =
      this._route.snapshot.queryParamMap.get('error_description');
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/dc415059-8540-4e1d-8e84-d3a0bdc2efb3', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: 'debug-session',
        runId: 'initial',
        hypothesisId: 'E',
        location: 'content.component.ts:30',
        message: 'callback error params',
        data: {
          hasError: !!errorParam,
          hasErrorDescription: !!errorDescriptionParam,
        },
        timestamp: Date.now(),
      }),
    }).catch(() => {});
    // #endregion
    // #region agent log
    const stateParam = this._route.snapshot.queryParamMap.get('state');
    fetch('http://127.0.0.1:7242/ingest/dc415059-8540-4e1d-8e84-d3a0bdc2efb3', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: 'debug-session',
        runId: 'initial',
        hypothesisId: 'D',
        location: 'content.component.ts:31',
        message: 'callback params presence',
        data: { hasState: !!stateParam },
        timestamp: Date.now(),
      }),
    }).catch(() => {});
    // #endregion
    if (this._code !== null && this._code !== undefined) {
      this._notificationService.customMessage(
        'Please wait...',
        'Processing',
        30000,
      );
      // #region agent log
      fetch(
        'http://127.0.0.1:7242/ingest/dc415059-8540-4e1d-8e84-d3a0bdc2efb3',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId: 'debug-session',
            runId: 'initial',
            hypothesisId: 'D',
            location: 'content.component.ts:34',
            message: 'Processing code flow started',
            data: { codePresent: true },
            timestamp: Date.now(),
          }),
        },
      ).catch(() => {});
      // #endregion
      this.processCode(this._code);
    }
  }

  public onGrantAccessButtonClick(): void {
    const client_id: string = 'VVFy4Ljbmwcc';
    const scopes: string[] = [
      'employee:register_read',
      'employee:inventory_read',
      'employee:admin_shops',
    ];
    const scopeParam = encodeURIComponent(scopes.join(' '));
    const redirectUri =
      environment.lightspeedRedirectUri ||
      `${window.location.origin}/dashboard`;
    const redirectParam = encodeURIComponent(redirectUri);
    const state = Math.random().toString(36).slice(2);

    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/dc415059-8540-4e1d-8e84-d3a0bdc2efb3', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: 'debug-session',
        runId: 'initial',
        hypothesisId: 'B',
        location: 'content.component.ts:66',
        message: 'env and redirect selection',
        data: {
          envName: (environment as any).envName || 'unknown',
          envRedirect: environment.lightspeedRedirectUri || '',
          origin: window.location.origin,
          chosenRedirect: redirectUri,
        },
        timestamp: Date.now(),
      }),
    }).catch(() => {});
    // #endregion

    const url: string =
      `https://cloud.lightspeedapp.com/auth/oauth/authorize` +
      `?response_type=code` +
      `&client_id=${client_id}` +
      `&redirect_uri=${redirectParam}` +
      `&scope=${scopeParam}` +
      `&state=${state}`;

    console.log(url);
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/dc415059-8540-4e1d-8e84-d3a0bdc2efb3', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: 'debug-session',
        runId: 'initial',
        hypothesisId: 'B',
        location: 'content.component.ts:42',
        message: 'OAuth authorize URL built',
        data: {
          url,
          hasRedirectUri: url.includes('redirect_uri'),
          redirectUri,
          scopeRaw: scopes.join(' '),
          scopeEncoded: scopeParam,
          usesSpaces: true,
          hasState: true,
        },
        timestamp: Date.now(),
      }),
    }).catch(() => {});
    // #endregion

    // Navigate in the same tab to avoid popup blockers
    window.location.assign(url);
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/dc415059-8540-4e1d-8e84-d3a0bdc2efb3', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: 'debug-session',
        runId: 'initial',
        hypothesisId: 'A',
        location: 'content.component.ts:62',
        message: 'location.assign invoked',
        data: {},
        timestamp: Date.now(),
      }),
    }).catch(() => {});
    // #endregion
  }

  public processCode(code: string) {
    const decodedUri: string = decodeURI(code);
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/dc415059-8540-4e1d-8e84-d3a0bdc2efb3', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: 'debug-session',
        runId: 'initial',
        hypothesisId: 'D',
        location: 'content.component.ts:51',
        message: 'processCode invoked',
        data: { decodedLength: decodedUri?.length || 0 },
        timestamp: Date.now(),
      }),
    }).catch(() => {});
    // #endregion
    this._lightSpeedAuthService.saveCode(decodedUri).subscribe((data) => {
      this._notificationService.removeAllNotifications();
      this._notificationService.showSuccessMessage(
        'Circana Reporting App has been authorized.',
      );
      // #region agent log
      fetch(
        'http://127.0.0.1:7242/ingest/dc415059-8540-4e1d-8e84-d3a0bdc2efb3',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId: 'debug-session',
            runId: 'initial',
            hypothesisId: 'D',
            location: 'content.component.ts:56',
            message: 'saveCode success',
            data: {},
            timestamp: Date.now(),
          }),
        },
      ).catch(() => {});
      // #endregion
    });
  }
}
